import React, { useEffect, useState } from 'react'
import Layout from '../../components/common/pageLayout'
import { toast } from 'react-toastify'
import ApplicationsList from '../../components/expense/Applications'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import constant from '../../constant'
import { v4_change_expense_application_staus, v4_expense_applications } from '../../actions/v4/expense'
import { v3_delete_expense_entry } from '../../actions/v3/expenses'
import moment from "moment";
import ExportColumnModal from '../../components/common/ExportColumnModal';
import RecordListFilters from '../../components/common/RecordListFilters';
import { exportRowsToExcel, getLoggedInUserRoleId } from '../../utils';
const List = (props) => {

    const location = useLocation();
    const { page } = location.state || {};
    const [data, setData] = useState(null)
    const [currentPage, setCurrentPage] = useState(page ? page : 1)
    const [limit] = useState(10)
    const [refresh, setRefresh] = useState(false)

    const [isExporting, setIsExporting] = useState(false);
    const [filters, setFilters] = useState({ fromDate: '', toDate: '', userId: '', subject: '' });
    const isAdmin = Number(getLoggedInUserRoleId()) === 1;

    const formatLastUpdated = (item) => {
        const timestamp = item?.MODIFIED_ON || item?.CREATED_ON;
        if (!timestamp) return '-';
        const parsed = moment(timestamp);
        return parsed.isValid() ? parsed.format("DD MMM YYYY, hh:mm A") : '-';
    };

    const expenseApplicationExportColumns = [
        { key: 'serialNo', label: 'S.No', value: (item, index) => index + 1 },
        { key: 'employeeName', label: 'Employee Name', value: (item) => item.FULL_NAME },
        { key: 'location', label: 'Location', value: (item) => item.LOCATION_NAME },
        { key: 'expenseType', label: 'Expense Type', value: (item) => item.EXPENSE_TYPE_NAME },
        { key: 'totalExpenseUsd', label: 'Total Expense (USD)', value: (item) => item.TOTAL_USD_EQUIV },
        { key: 'totalItems', label: 'Total Items', value: (item) => item.expense_items?.length || 0 },
        { key: 'status', label: 'Status', value: (item) => item.STATUS },
        { key: 'lastUpdated', label: 'Last Updated', value: formatLastUpdated },
    ];

    useEffect(() => {
        v4_expense_applications(currentPage, limit, filters).then((res) => {
            if (res.status) {
                setData(res.result);
                props.history.push(constant.Authedcomponent.expenseApplications.url, {
                    page: currentPage // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }, [currentPage, limit, refresh, filters])

    const updateFilters = (nextFilters) => {
        setCurrentPage(1);
        setFilters(nextFilters);
    };

    const changeApplicationStatus = (leaveId, status, remark = '') => {
        v4_change_expense_application_staus({ status, remark }, leaveId).then((res) => {
            if (res.status) {
                toast.success(res.result?.message || 'Status updated successfully');
                // Refresh data after status change
                setRefresh(!refresh)
            } else {
                toast.error(res.error || 'Failed to update status');
            }
        }).catch((err) => {
            toast.error('Error occurred while changing status');
        });
    };

    const deleteExpense = async (expenseId) => {
        if (!window.confirm('Delete this expense entry? This cannot be undone.')) return;
        const res = await v3_delete_expense_entry(expenseId);
        if (res.status) {
            toast.success(res.result?.message || 'Expense entry deleted.');
            setRefresh(!refresh);
        } else toast.error(res.error || 'Unable to delete expense entry.');
    };

    const exportAllExpenses = async (selectedColumns = expenseApplicationExportColumns) => {
        try {
            setIsExporting(true);
            toast.info("Preparing Excel export, please wait...");

            let allExpenses = [];
            let pageNum = 1;
            const exportLimit = 100; // Fetch 100 per page for faster export

            while (true) {
                const res = await v4_expense_applications(pageNum, exportLimit, filters);
                if (!res.status) break;

                const currentExpenses = res.result?.expenses || [];
                allExpenses = [...allExpenses, ...currentExpenses];

                // If we fetched fewer than the limit, it means we’re done
                if (currentExpenses.length < exportLimit) break;

                pageNum++;
            }

            if (allExpenses.length === 0) {
                toast.warn("No data found to export");
                setIsExporting(false);
                return;
            }

            exportRowsToExcel({
                rows: allExpenses,
                columns: selectedColumns,
                sheetName: "All Expenses",
                fileName: `Expense_Report_${moment().format("YYYYMMDD_HHmmss")}.xlsx`,
            });

            toast.success("Excel exported successfully!");
        } catch (error) {
            console.error(error);
            toast.error("Error while exporting data");
        } finally {
            setIsExporting(false);
        }
    };
    return (
        <Layout
            title={'Submitted Expenses'}
        >
            <RecordListFilters value={filters} onChange={updateFilters} />
            <div className="d-flex justify-content-end mb-3">
                <button
                    className="btn btn-sm btn-primary me-2"
                    style={{
                        backgroundImage:
                            "linear-gradient(90deg, rgb(104, 149, 180), rgb(38, 85, 120))"
                    }}
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#expense-application-export-columns-modal"
                    disabled={isExporting}
                >
                    {isExporting ? (
                        <>
                            <i className="bx bx-loader-alt bx-spin"></i> Exporting...
                        </>
                    ) : (
                        <>
                            <i className="mdi mdi-file-excel-outline label-icon"></i> Export All to Excel
                        </>
                    )}
                </button>
            </div>
            {data && <ApplicationsList
                limit={limit}
                data={data}
                changeApplicationStatus={changeApplicationStatus}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isAdmin={isAdmin}
                onDelete={deleteExpense}
            />}
            <ExportColumnModal
                modalId="expense-application-export-columns-modal"
                title="Select Expense Columns"
                columns={expenseApplicationExportColumns}
                onExport={exportAllExpenses}
                isExporting={isExporting}
            />
        </Layout>
    )
}

export default List
